import { Col, DatePicker, Form, InputNumber, Row } from "antd";
import dayjs from "dayjs";
import MultiSelectTag from "../../../components/multi-select-tag";
import {
  matchedFlagOptions,
  matchedTeamOptions,
} from "../../../constants/ap-workflow";
import { DATE_FORMAT } from "../../../constants/common";
import { IMasterDataType } from "../../../interfaces/master-data";

interface FilterApWorkflowProps {
  masterData?: any;
}

const FilterTourEventOrOtherWorkflow: React.FC<FilterApWorkflowProps> = ({
  masterData,
}) => {
  const { currencies = [] } = masterData;
  return (
    <>
      <Row gutter={16}>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <>
              <Col span={12}>
                <Form.Item label="From Total Cost" name="espAmountFrom">
                  <InputNumber max={getFieldValue("espAmountTo")} style={{ width: "100%" }} placeholder="From" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="To Total Cost" name="espAmountTo">
                  <InputNumber min={getFieldValue("espAmountFrom") || 1} style={{ width: "100%" }} placeholder="To" />
                </Form.Item>
              </Col>
            </>
          )}
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <>
              <Col span={12}>
                <Form.Item label="Departure Date From" name="espDepartureDateFrom">
                  <DatePicker
                    format={DATE_FORMAT}
                    maxDate={dayjs(getFieldValue("espDepartureDateTo"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="From"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Departure Date To" name="espDepartureDateTo">
                  <DatePicker
                    format={DATE_FORMAT}
                    minDate={dayjs(getFieldValue("espDepartureDateFrom"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="To"
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <>
              <Col span={12}>
                <Form.Item label="Due Date From" name="espDateFrom">
                  <DatePicker
                    format={DATE_FORMAT}
                    maxDate={dayjs(getFieldValue("espDateTo"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="From"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Due Date To" name="espDateTo">
                  <DatePicker
                    format={DATE_FORMAT}
                    minDate={dayjs(getFieldValue("espDateFrom"), DATE_FORMAT)}
                    style={{ width: "100%" }}
                    placeholder="To"
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Form.Item>
        <Col span={24}>
          <Form.Item label="Currency" name="espCurrencies">
            <MultiSelectTag
              allowClear
              showSearch
              placeholder="All"
              options={currencies.map((item: IMasterDataType) => ({
                value: item.code,
                label: `${item.code} - ${item.label}`,
              }))}
              tagDisplay="value"
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Flag" name="flags">
            <MultiSelectTag allowClear showSearch placeholder="All" options={matchedFlagOptions} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item label="Team" name="teams">
            <MultiSelectTag allowClear showSearch placeholder="All" options={matchedTeamOptions} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default FilterTourEventOrOtherWorkflow;
